//Creates tooltip and makes it invisiblae
var div = d3.select(".gia-chart").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

//Sets dimensions
var margin = {top: 0, left: 0, bottom: 0, right: 0},
  width = d3.select(".gia-chart").node().clientWidth,
  width = width - margin.left - margin.right,
  mapRatio = .6,
  height = width * mapRatio;

//Tells the map what projection to use
var projection = d3.geo.albersUsa()
  .scale(width *1.25)
  .translate([width / 2, height / 2]);

//Tells the map how to draw the paths from the projection
var path = d3.geo.path()
  .projection(projection);

//Appened svg to page
var map = d3.select(".gia-chart").append("svg")
  .style('height', height + 'px')
  .style('width', width + 'px');  

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/CampaignEvents.csv")
  .await(ready);

//Moves selection to front
d3.selection.prototype.moveToFront = function() {
  return this.each(function(){
    this.parentNode.appendChild(this);
  });
}; 

//Moves selection to back
d3.selection.prototype.moveToBack = function() { 
  return this.each(function() { 
    var firstChild = this.parentNode.firstChild; 
      if (firstChild) { 
        this.parentNode.insertBefore(this, firstChild); 
      } 
    }); 
  }; 

function ready(error, us, cities) {
  if (error) throw error; 

  console.log(cities); 

  //Append states
  map.append("g")
    .attr("class", "states")
    .selectAll("path")
    .data(topojson.feature(us, us.objects.states).features)
    .enter().append("path")
    .attr("d", path)
    .style("fill", function(d) {
      if(d.id === "12") {
        return "#dcdcdc"
      }
      else if(d.id === "26"){
        return "#dcdcdc"
      }
      else if(d.id === "4"){
        return "#dcdcdc"
      }
      else if(d.id === "8"){
        return "#dcdcdc"
      }
      else if(d.id === "32"){
        return "#dcdcdc"
      }
      else if(d.id === "35"){
        return "#dcdcdc"
      }
      else if(d.id === "37"){
        return "#dcdcdc"
      }
      else if(d.id === "39"){
        return "#dcdcdc"
      }
      else if(d.id === "42"){
        return "#dcdcdc"
      }
      else if(d.id === "55"){
        return "#dcdcdc"
      }
      else if(d.id === "33"){
        return "#dcdcdc"
      }
      else if(d.id === "19"){
        return "#dcdcdc"
      }
      else if(d.id === "27"){
        return "#dcdcdc"
      }
      else if(d.id === "51"){
        return "#dcdcdc"
      }
      else {
        return "#eaeaea"
      }
    });

  //Add cities
  map.selectAll("circle")
    .data(cities)
    .enter()
    .append("circle")
    .attr("cx", function(d) {
      return projection([d.longitude, d.latitude])[0];
    })
    .attr("cy", function(d) {
      return projection([d.longitude, d.latitude])[1];
    })
    .attr("r", function(d) {
      if(width < 400){
        return 2;
      }
      else {
        return 3;
      }
    })
    .style("fill", function(d) {
      if(d.candidate === "Trump") {
        return "#d61d00"
      }
      else {
        return "#005689"
      }
    })
    //.style("stroke", "#305491")
    //.style("stroke-width", 1)
    //.style("stroke", "#ffffff")
    .style("opacity", 0.7)  

    /*Hovers
    .on("mouseover", function(d) {
      var sel = d3.select(this);
        sel.moveToFront();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': '#333333', 'stroke-width': 1.5});
      div.transition().duration(300)
        .style("opacity", 1)
      div.text(dataByFIPS[d.id] + "% of " + stateByFIPS[d.id] +"'s eligible voters are Latino");
    })

    .on("mouseout", function() {
      var sel = d3.select(this);
        sel.moveToBack();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': 'white', 'stroke-width': 1});
      div.transition().duration(300)
        .style("opacity", 0);
    }) 
    */


  //RESPONSIVENESS
  d3.select(window).on('resize', resize);

  function resize() {

    var width = d3.select(".gia-chart").node().clientWidth;

    //Adjust things when the window size changes
    width = width - margin.left - margin.right;
    height = width * mapRatio;
    
    //Update projection
    var newProjection = d3.geo.albersUsa()
      .scale(width*1.25)
      .translate([width / 2, height / 2]);

    //Update path
    path = d3.geo.path()
      .projection(newProjection);  

    map.selectAll("circle")
    .attr("cx", function(d) {
      return newProjection([d.longitude, d.latitude])[0];
    })
    .attr("cy", function(d) {
      return newProjection([d.longitude, d.latitude])[1];
    })   

    //Resize the map container
    map
      .style('width', width + 'px')
      .style('height', height + 'px');

    //Resize the map
    map.selectAll("path").attr('d', path);
 
  }
}